/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instance.
 * */

import appConfig from "../../app-config";

const TOKEN_KEY = `access_token_${appConfig.VUE_APP_COOKIE_NAME}`;
const REFRESH_TOKEN_KEY = `refresh_token_${appConfig.VUE_APP_COOKIE_NAME}`;
const TENANT_KEY = `tenant_${appConfig.VUE_APP_COOKIE_NAME}`;
const TENANT_USER_CODE_KEY = `tenant_user_code${appConfig.VUE_APP_COOKIE_NAME}`

const TokenStorage = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  saveToken(accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken);
  },

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  saveRefreshToken(refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },

  getTenant() {
    return localStorage.getItem(TENANT_KEY);
  },

  saveTenant(tenant) {
    localStorage.setItem(TENANT_KEY, tenant);
  },

  getTenantUserCode(){
    return localStorage.getItem(TENANT_USER_CODE_KEY);
  },

  saveTenantUserCode(tenantUserCode){
    localStorage.setItem(TENANT_USER_CODE_KEY, tenantUserCode);
  },

  clear() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(TENANT_KEY);
    localStorage.removeItem(TENANT_USER_CODE_KEY);
  },
};

export { TokenStorage };
